var _circle, _rect, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5759_1445)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2515,
    cy: 28.249,
    r: 19.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5759_1445",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: -7,
    width: 71,
    height: 71
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6.24854,
    y: -6.25098,
    width: 69.5,
    height: 69.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5759_1445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5029 42.998C29.3246 42.998 30.0133 42.7201 30.5692 42.1643C31.125 41.6085 31.4029 40.9197 31.4029 40.098C31.4029 39.2764 31.125 38.5876 30.5692 38.0318C30.0133 37.476 29.3246 37.198 28.5029 37.198C27.6813 37.198 26.9925 37.476 26.4367 38.0318C25.8808 38.5876 25.6029 39.2764 25.6029 40.098C25.6029 40.9197 25.8808 41.6085 26.4367 42.1643C26.9925 42.7201 27.6813 42.998 28.5029 42.998ZM25.6029 31.398H31.4029V13.998H25.6029V31.398ZM28.5029 57.498C24.4913 57.498 20.7213 56.7368 17.1929 55.2143C13.6646 53.6918 10.5954 51.6255 7.98543 49.0156C5.37543 46.4056 3.30918 43.3364 1.78668 39.808C0.26418 36.2797 -0.49707 32.5097 -0.49707 28.498C-0.49707 24.4864 0.26418 20.7164 1.78668 17.188C3.30918 13.6597 5.37543 10.5905 7.98543 7.98055C10.5954 5.37055 13.6646 3.3043 17.1929 1.7818C20.7213 0.259297 24.4913 -0.501953 28.5029 -0.501953C32.5146 -0.501953 36.2846 0.259297 39.8129 1.7818C43.3413 3.3043 46.4104 5.37055 49.0204 7.98055C51.6304 10.5905 53.6967 13.6597 55.2192 17.188C56.7417 20.7164 57.5029 24.4864 57.5029 28.498C57.5029 32.5097 56.7417 36.2797 55.2192 39.808C53.6967 43.3364 51.6304 46.4056 49.0204 49.0156C46.4104 51.6255 43.3413 53.6918 39.8129 55.2143C36.2846 56.7368 32.5146 57.498 28.5029 57.498Z",
    fill: "#C3CF11"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5759_1445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(-0.248535 -0.250977)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.c5a3518f0d7df02a33331d66dd091bce.svg";
export { ForwardRef as ReactComponent };